if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleDesktopScroll);
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      // Mobile: use IntersectionObserver as before
      if (!theme.mediaMatches.md && this.productForm) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === this.productForm) {
              this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
            }
          });
        });
        observer.observe(this.productForm);
      }

      // Desktop: show panel after 900px scroll
      if (theme.mediaMatches.md) {
        this.handleDesktopScroll = () => {
          this.classList.toggle('sticky-atc-panel--out', window.scrollY < 800);
        };
        window.addEventListener('scroll', this.handleDesktopScroll, { passive: true });
        // Set initial state
        this.classList.toggle('sticky-atc-panel--out', window.scrollY < 800);
      }

      window.addEventListener('scroll', StickyAtcPanel.handleScroll, { passive: true });
    }

    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}